module.exports = {
    file(filename) {
        //return `http://localhost:3333/files/${filename}`;
        return `https://participacao-social.ana.gov.br/api/files/${filename}`;
    }
}